export default "__VITE_ASSET__DRjqw0TJ__"